import { Food } from '../model/food.model';
import {helpers} from "../helpers";

export async function updateFood(food) {
    if (!(food instanceof Food))
        throw new Error('Unsupported type');

    const foodDto = helpers.deepClone(food);

    const response = await axios.put('/foods/' + foodDto.externalId, { foodDto });

    return {
        externalId: foodDto.externalId,
        createdOrReplacedProducts: response.data.created_or_replaced_products,
    };
}
